import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const WishlistContext = createContext(null);

export function WishlistProvider({ children }) {
  const { user } = useAuth();
  const [ids, setIds] = useState([]);

  useEffect(() => {
    if (user) api.get("/my/wishlist/ids").then((r) => setIds(r.data)).catch(() => {});
    else setIds([]);
  }, [user]);

  const toggle = async (pid) => {
    if (!user) return { needLogin: true };
    const { data } = await api.post(`/my/wishlist/${pid}`);
    setIds(data.wishlist);
    return { added: data.added };
  };

  const isWished = (pid) => ids.includes(pid);

  return (
    <WishlistContext.Provider value={{ ids, toggle, isWished, count: ids.length }}>
      {children}
    </WishlistContext.Provider>
  );
}

export const useWishlist = () => useContext(WishlistContext);
